import Vendor from "../Vendor";

describe("Vendor model", () => {
  describe("isVendorDisabled", () => {
    test("returns true when vendor is archived", () => {
      const vendor = { id: 1, name: "Test Vendor", isArchived: true };
      expect(Vendor.isVendorDisabled(vendor)).toBe(true);
    });

    test("returns true when vendor status includes locked", () => {
      const vendor = {
        id: 1,
        name: "Test Vendor",
        status: ["locked"],
      };
      expect(Vendor.isVendorDisabled(vendor)).toBe(true);
    });

    test("returns true when vendor is both archived and locked", () => {
      const vendor = {
        id: 1,
        name: "Test Vendor",
        isArchived: true,
        status: ["locked"],
      };
      expect(Vendor.isVendorDisabled(vendor)).toBe(true);
    });

    test("returns false when vendor is not archived and not locked", () => {
      const vendor = {
        id: 1,
        name: "Test Vendor",
        isArchived: false,
        status: ["active"],
      };
      expect(Vendor.isVendorDisabled(vendor)).toBe(false);
    });

    test("returns false when vendor has no isArchived property", () => {
      const vendor = { id: 1, name: "Test Vendor", status: ["active"] };
      expect(Vendor.isVendorDisabled(vendor)).toBe(false);
    });

    test("returns false when vendor is null", () => {
      expect(Vendor.isVendorDisabled(null)).toBe(false);
    });

    test("returns false when vendor is undefined", () => {
      expect(Vendor.isVendorDisabled(undefined)).toBe(false);
    });
  });

  describe("labelProperty", () => {
    test("returns vendor name with (Archived) suffix when vendor is archived", () => {
      const vendor = { id: 1, name: "Test Vendor", isArchived: true };
      expect(Vendor.labelProperty(vendor)).toBe("Test Vendor (Archived)");
    });

    test("returns vendor name with (Locked) suffix when vendor is locked", () => {
      const vendor = {
        id: 1,
        name: "Test Vendor",
        status: ["locked"],
      };
      expect(Vendor.labelProperty(vendor)).toBe("Test Vendor (Locked)");
    });

    test("prioritizes (Archived) suffix when vendor is both archived and locked", () => {
      const vendor = {
        id: 1,
        name: "Test Vendor",
        isArchived: true,
        status: ["locked"],
      };
      expect(Vendor.labelProperty(vendor)).toBe("Test Vendor (Archived)");
    });

    test("returns vendor name without suffix when vendor is active", () => {
      const vendor = {
        id: 1,
        name: "Test Vendor",
        isArchived: false,
        status: ["active"],
      };
      expect(Vendor.labelProperty(vendor)).toBe("Test Vendor");
    });

    test("returns empty string when vendor has no name", () => {
      const vendor = { id: 1, isArchived: false };
      expect(Vendor.labelProperty(vendor)).toBe("");
    });

    test("returns vendor name without suffix when vendor has no status or isArchived", () => {
      const vendor = { id: 1, name: "Test Vendor" };
      expect(Vendor.labelProperty(vendor)).toBe("Test Vendor");
    });
  });

  describe("relations", () => {
    test("belongsTo relations", () => {
      expect(Vendor.belongsTo.map(relation => relation.name)).toMatchSnapshot();
    });

    test("hasMany relations", () => {
      expect(Vendor.hasMany.map(relation => relation.name)).toMatchSnapshot();
    });
  });
});
